import './TeamInviteMembers.scss'

import {EntryData, WysiwygType} from '../../types'
import {FormSectionType, FormStepType, FormType} from '../blocks/FormBlock'
import {Hero, HeroType} from '../layout/Hero'
import React, {useState} from 'react'

import {Blocks} from '../blocks/Blocks'
import {Breadcrumbs} from '../layout/Breadcrumbs'
import {Theme} from '../Theme'
import addressInfoSection from '../evenementen/layout/MemberRegistration/sections/addressInfoSection'
import personalInfoSection from '../evenementen/layout/MemberRegistration/sections/personalInfoSection'
import step3Section from '../evenementen/layout/MemberRegistration/sections/step3section'
import {style} from '../../util/style'

const styles = style('teaminvitemembers', [
	'thanks',
	'mollieGoToPayment',
	'paid'
])

export type eclThanksType = {
	title: string
	text: WysiwygType
	button?: {text: string; url: string}
}

type mollieThanksType = eclThanksType & {
	checkoutUrl: string
}

type thanksType =
	| (eclThanksType & {isECL: true})
	| (mollieThanksType & {isECL: false})

export const TeamInviteMember: React.FC<{
	hero: HeroType
	parents: Array<EntryData>
	title: string
	reCaptchaKey: string
	eventTitle: string
	extra_sections?: Array<FormSectionType>
	inviteHash?: string
	member?: {
		uuid: string
		firstname: string
		lastname: string
		email: string
		phone: string
		mobile: string
		birthdate: string
		gender: 'm' | 'f' | 'x'
		street: string
		housenumber: string
		box: string
		zip: string
		city: string
		howYouKnow: string
		extra_data: {[key: string]: any}
		payment_status: string
	}
	thanks_paid?: eclThanksType
}> = ({...props}) => {
	const {
		hero,
		title,
		reCaptchaKey,
		parents,
		inviteHash,
		member,
		eventTitle,
		extra_sections,
		thanks_paid
	} = props

	const [showWhereField, setShowWhereField] = useState<boolean>(
		member && member.howYouKnow === 'advertisement'
	)
	const [thanks, setThanks] = useState<thanksType>(null)

	const paid: boolean = member && member.payment_status === 'paid'

	const data: {[key: string]: string} = {
		uuid: member?.uuid,
		'1-1-1': member?.firstname,
		'1-1-2': member?.lastname,
		'1-1-3': member?.email,
		'1-1-4': member?.phone,
		'1-1-5': member?.mobile,
		'1-1-6': member?.birthdate,
		'1-1-7': member?.gender,
		'1-2-1': member?.street,
		'1-2-2': member?.housenumber,
		'1-2-3': member?.box,
		'1-2-4': member?.zip,
		'1-2-5': member?.city,
		'3-1-1': member?.howYouKnow || 'collaborator'
	}

	if (member && member.extra_data.length > 0) {
		extra_sections.forEach((section: FormSectionType) => {
			section.fields.forEach((field: FormType | any) => {
				if (member.extra_data[field.id] && field.channel !== 'files') {
					data[`2-${section.id}-${field.id}`] = member.extra_data[field.id]
				}
			})
		})
	}

	const getStep1 = (): FormStepType => {
		const stepId: number = 1
		return {
			id: stepId,
			parent_id: 0,
			channel: 'step',
			label: '',
			submit_text: 'Volgende stap', // todo: translate
			sections: [
				{
					...personalInfoSection,
					parent_id: stepId
				},
				{
					...addressInfoSection,
					parent_id: stepId
				}
			]
		}
	}

	const getStep2 = (): FormStepType => {
		const stepId: number = 2

		return {
			id: stepId,
			parent_id: 0,
			channel: 'step',
			label: '',
			submit_text: 'Volgende stap', // todo: translate
			sections: [...extra_sections]
		}
	}

	const getStep3 = (): FormStepType => {
		const stepId: number = 3
		const section = {
			...step3Section,
			parent_id: stepId
		}

		return {
			id: stepId,
			parent_id: 0,
			channel: 'step',
			label: '',
			submit_text: 'Volgende stap', // todo: translate
			sections: [
				{
					...section,
					fields: section.fields
						.filter((field) => (showWhereField ? true : field.name !== 'where'))
						.map((field) =>
							field.name === 'intro'
								? {
										...field,
										text: field.text.replace('{{eventName}}', eventTitle)
								  }
								: field.name === 'howYouKnow'
								? {
										...field,
										label: ''
								  }
								: field
						)
				}
			]
		}
	}

	const getSteps = (): Array<FormStepType> => {
		const steps: Array<FormStepType> = [getStep1()]
		if (extra_sections) steps.push(getStep2())
		steps.push(getStep3())
		return steps
	}

	const handleThanksView = () => {
		const {isECL, title: thanksTitle, text, button} = thanks
		if (isECL === true)
			return <EclThanksView title={thanksTitle} text={text} button={button} />
		const {checkoutUrl} = thanks as mollieThanksType
		return (
			<MollieGoToPaymentView
				title={thanksTitle}
				text={text}
				button={button}
				checkoutUrl={checkoutUrl}
			/>
		)
	}

	return (
		<div className={styles()}>
			<Hero {...hero} markedtitle={title} />
			<Breadcrumbs parents={parents} title={title} />
			<Theme.Container>
				{paid && thanks_paid && (
					<PaidView title={thanks_paid.title} text={thanks_paid.text} />
				)}
				{!paid && thanks && handleThanksView()}
				{!paid && !thanks && (
					<Blocks
						blocks={[
							{
								type: 'form' as 'form',
								path: '',
								reCaptchaKey,
								requestUri: `${window.location.pathname}?${
									member && member.uuid
										? `confirm=${member.uuid}`
										: `invite=${inviteHash}`
								}`,
								id: 1,
								pageId: 0,
								steps: getSteps(),
								data,
								useEffect: false,
								onChange: (k, v) => {
									if (k === '3-1-1') {
										setShowWhereField(v === 'advertisement')
									}
								},
								onSubmit: (e) => {
									setThanks(e as thanksType)
								}
							}
						]}
					/>
				)}
			</Theme.Container>
		</div>
	)
}

const EclThanksView: React.FC<eclThanksType> = ({title, text, button}) => {
	return (
		<div className={styles.thanks()}>
			<Theme.H2 className={styles.thanks('title')} mod="bold">
				{title}
			</Theme.H2>
			<div className={styles.thanks('text')}>
				<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
			</div>
			{button && (
				<div className={styles.thanks('bottom')}>
					<div className={styles.thanks('bottom-item')}>
						<Theme.Button to={button.url} className={styles.thanks('button')}>
							{button.text}
						</Theme.Button>
					</div>
				</div>
			)}
		</div>
	)
}

const MollieGoToPaymentView: React.FC<mollieThanksType> = ({
	title,
	text,
	button,
	checkoutUrl
}) => {
	window.location.href = checkoutUrl

	return (
		<div className={styles.mollieGoToPayment()}>
			<Theme.H2 className={styles.mollieGoToPayment('title')} mod="bold">
				{title}
			</Theme.H2>
			<div className={styles.mollieGoToPayment('text')}>
				<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
			</div>
			{button && (
				<div className={styles.mollieGoToPayment('bottom')}>
					<div className={styles.mollieGoToPayment('bottom-item')}>
						<Theme.Button
							to={button.url}
							className={styles.mollieGoToPayment('button')}
						>
							{button.text}
						</Theme.Button>
					</div>
				</div>
			)}
		</div>
	)
}

const PaidView: React.FC<{title: string; text: WysiwygType}> = ({
	title,
	text
}) => {
	return (
		<div className={styles.paid()}>
			<Theme.H2 className={styles.paid('title')} mod="bold">
				{title}
			</Theme.H2>
			<div className={styles.paid('text')}>
				<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
			</div>
		</div>
	)
}
